import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Page } from "@/components/PublicLayout";
import { BranchDivider, ScriptMark } from "@/components/Brand";

const fmt = (d) => new Date(d).toLocaleDateString("en-US", { timeZone: "America/Los_Angeles", dateStyle: "long" });

export default function VerifyPage() {
  const { number } = useParams();
  const { data, isLoading } = useQuery({ queryKey: ["verify", number], queryFn: async () => (await api.get(`/verify/${encodeURIComponent(number)}`)).data });
  return (
    <Page title="Verify A Certificate" lede="Certificates of completion are issued when a person finishes their video series. Enter or scan a certificate number to confirm it." testId="verify-page">
      <div className="max-w-xl">
        {isLoading && <p className="text-ink-500" role="status">Checking…</p>}
        {data && (
          <div className={`border-2 p-6 ${data.valid ? "border-olive-900 bg-cream-100" : "border-terracotta-600 bg-cream-100"}`} data-testid={data.valid ? "verify-valid" : "verify-invalid"}>
            <div className="flex items-center gap-3">
              {data.valid ? <CheckCircle2 className="h-8 w-8 text-olive-900" aria-hidden="true" /> : <XCircle className="h-8 w-8 text-terracotta-600" aria-hidden="true" />}
              <h2 className="text-2xl">{data.valid ? "This certificate is valid" : data.revoked ? "This certificate was revoked" : "No certificate matches this number"}</h2>
            </div>
            <dl className="mt-5 divide-y divide-sage-400/50 border-y border-sage-400/50 text-base">
              <div className="grid grid-cols-3 gap-3 py-2.5"><dt className="text-ink-500">Number</dt><dd className="col-span-2 font-mono" data-testid="verify-number">{data.number}</dd></div>
              {data.valid && <><div className="grid grid-cols-3 gap-3 py-2.5"><dt className="text-ink-500">Issued to</dt><dd className="col-span-2">{data.holder}</dd></div>
                <div className="grid grid-cols-3 gap-3 py-2.5"><dt className="text-ink-500">Series</dt><dd className="col-span-2">{data.series_title}</dd></div>
                <div className="grid grid-cols-3 gap-3 py-2.5"><dt className="text-ink-500">Issued</dt><dd className="col-span-2">{fmt(data.issued_at)}</dd></div></>}
            </dl>
            {data.valid && <div className="mt-6 flex items-center gap-4"><ScriptMark className="h-12 w-auto" /><p className="text-sm text-ink-500">Pastoral Counseling Ministry, Patria Church</p></div>}
          </div>
        )}
        <BranchDivider className="mt-10" />
        <p className="mt-6 text-sm text-ink-500">Only the certificate holder's first name and last initial are shown. <Link to="/how-it-works" className="link">How the care journey works</Link></p>
      </div>
    </Page>
  );
}
